import { postBatchPresignedUploadUrl } from '../api/upload';
import { UPLOAD_SUPPORT_MEDIA_FILE_EXTENSION } from '../constants/upload';
import { EPrivacySetting } from '../types';
import { AudioManager } from './media';
import { EFileType, IPostBatchPresignedUploadUrlReq } from '../types/upload';

export function uploadImageFile({
  file,
  userId,
  privacy_setting = EPrivacySetting.Public,
}: {
  file: File;
  userId: number;
  privacy_setting?: EPrivacySetting;
}) {
  return new Promise<{ pathname: string; url: string }>(async (resolve, reject) => {
    const fetchUploadUrl = async (params: Partial<IPostBatchPresignedUploadUrlReq>) => {
      // 调用你的 API 获取上传 URL
      const response = await postBatchPresignedUploadUrl({
        user_id: userId,
        file_suffix: 'jpeg',
        count: 1,
        privacy_setting: EPrivacySetting.Public,
        file_type: EFileType.Picture,
        folder_name: userId + '',
        ...params,
      });

      const actionUrl = response.upload_list[0].upload_url;

      return actionUrl;
    };
    try {
      const file_suffix = file.type.split('/').pop();
      // 动态获取上传 URL
      const actionUrl = await fetchUploadUrl({
        file_suffix,
        privacy_setting,
      });

      // 发起上传请求
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', actionUrl, true);
      xhr.setRequestHeader('Content-Disposition', 'inline');
      xhr.setRequestHeader('Content-Type', '');
      // 请求完成
      xhr.onload = () => {
        if (xhr.status === 200) {
          try {
            // 将桶的链接转为 cdn 地址
            const url = new URL(actionUrl);
            resolve({ pathname: url.pathname, url: actionUrl.split('?')?.[0] || actionUrl });
          } catch {
            //
          }
        } else {
          reject(new Error(xhr.statusText));
        }
      };

      // 请求错误
      xhr.onerror = () => {
        reject(new Error('Network error'));
      };

      // 发送请求
      xhr.send(file);
    } catch (error) {
      reject(error);
    }
  });
}

export function uploadMediaFile({
  file,
  userId,
  privacy_setting = EPrivacySetting.Private,
}: {
  file: File;
  userId: number;
  privacy_setting?: EPrivacySetting;
}) {
  return new Promise<{ pathname: string; url: string }>(async (resolve, reject) => {
    const fetchUploadUrl = async (params: Partial<IPostBatchPresignedUploadUrlReq>) => {
      const response = await postBatchPresignedUploadUrl({
        user_id: userId,
        count: 1,
        file_suffix: 'mp3',
        privacy_setting: EPrivacySetting.Private,
        file_type: EFileType.Sound,
        folder_name: userId + '',
        ...params,
      });

      const actionUrl = response.upload_list[0].upload_url;

      return actionUrl;
    };
    try {
      const isMediaContent = await AudioManager.checkIsMediaContent(file);
      await AudioManager.closeContext();
      if (!isMediaContent) {
        throw new Error('unsupported file content');
      }
      // 获取文件后缀 (不宜依赖file.type确定文件类型， https://developer.mozilla.org/zh-CN/docs/Web/API/Blob/type)
      const file_suffix = file.name.split('.').pop()?.toLocaleLowerCase() || '';
      if (!file_suffix || !UPLOAD_SUPPORT_MEDIA_FILE_EXTENSION.includes(file_suffix)) {
        throw new Error('The file type is not supported');
      }
      // 动态获取上传 URL
      const actionUrl = await fetchUploadUrl({
        file_suffix,
        privacy_setting,
      });

      // 发起上传请求
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', actionUrl, true);
      xhr.setRequestHeader('Content-Disposition', 'inline');
      xhr.setRequestHeader('Content-Type', '');
      // 请求完成
      xhr.onload = () => {
        if (xhr.status === 200) {
          try {
            // 将桶的链接转为 cdn 地址
            const url = new URL(actionUrl);
            resolve({ pathname: url.pathname, url: actionUrl.split('?')?.[0] || actionUrl });
          } catch {
            //
          }
        } else {
          reject(new Error(xhr.statusText));
        }
      };

      // 请求错误
      xhr.onerror = () => {
        reject(new Error('Network error'));
      };

      // 发送请求
      xhr.send(file);
    } catch (error) {
      reject(error);
    }
  });
}
